import {createSlice} from "@reduxjs/toolkit";
import {getScheduleDetail} from "./action";

const initialState = {
	state: {},
	loading: true,
	error: ''
} as BaseState<ScheduleDetailState>

const slice = createSlice({
	name: 'scheduleSlice',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getScheduleDetail.pending, (state) => ({
				...state,
				loading: true
			})
		)
		builder.addCase(getScheduleDetail.fulfilled, (state, action) => {
				const { id, status, reason, details, venue_id: venueId, venue, created_at, updated_at } = action.payload
				return {
					state: {
						id,
						status,
						reason,
						details,
						venue,
						venue_id: venueId,
						created_at,
						updated_at
					},
					loading: false,
					error: null
				}
			}
		)
		builder.addCase(getScheduleDetail.rejected, () => ({
				state: {
					id: '',
					reason: '',
					venue_id: '',
					status: '',
					details: [],
					created_at: 0,
					updated_at: 0
				},
				loading: false,
				error: 'Failed to get facts, please try again'
			})
		)
	}
})

export default slice
